import React, { useEffect } from "react";
import Experience from "./Experience/Experience";

const Experiences = (props) => {
  useEffect(() => {
    document.title = "Experiences";
  }, []);

  let mycolor = "#B8B875";

  const renderedExp = props.experiences.map((exp) => {
    return (
      <Experience
        name={exp.name}
        position={exp.position}
        desc={exp.desc}
        date={exp.date}
        key={exp.key}
      />
    );
  });

  if (props.color !== mycolor) props.backColor(mycolor);

  return (
    <div style={{ marginTop: "17px", fontFamily: "Roboto Slab" }}>
      <h1 className="ui header" style={{ color: "#E4F011", fontSize: "30px" }}>
        Experience👨‍💻
      </h1>
      <div className="ui cards">{renderedExp}</div>
    </div>
  );
};

export default Experiences;
